import styled from '@emotion/styled';

export const StyledAnswerGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 15px;
  row-gap: 10px;
`;
